const mainContent = document.querySelector('.ratesPrint #main');

if (mainContent) {
    const printButton = document.createElement('button');
    printButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" width="24px" viewBox="0 0 48 48"><path fill="#ffffff" d="M32.9 15.6V9H15.1v6.6h-3V6h23.8v9.6ZM7 18.6h34-28.9Zm29.95 4.75q.6 0 1.05-.45.45-.45.45-1.05 0-.6-.45-1.05-.45-.45-1.05-.45-.6 0-1.05.45-.45.45-.45 1.05 0 .6.45 1.05.45.45 1.05.45ZM32.9 39v-9.6H15.1V39Zm3 3H12.1v-8.8H4V20.9q0-2.25 1.525-3.775T9.3 15.6h29.4q2.25 0 3.775 1.525T44 20.9v12.3h-8.1ZM41 30.2v-9.3q0-1-.65-1.65-.65-.65-1.65-.65H9.3q-1 0-1.65.65Q7 19.9 7 20.9v9.3h5.1v-3.8h23.8v3.8Z"/></svg> Print Page';
    printButton.setAttribute('class', 'print-button');
    printButton.addEventListener('click', function(e) {
        window.print();
        return false;
    })
    mainContent.appendChild(printButton);
}